const MinoanEra = {
  id: '3',
  name: 'Minoan Era'
};

export default MinoanEra;
